import CallEndIcon from '@mui/icons-material/CallEnd'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import MicIcon from '@mui/icons-material/Mic'
import MicOffIcon from '@mui/icons-material/MicOff'
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent'
import VideocamIcon from '@mui/icons-material/Videocam'
import VideocamOffIcon from '@mui/icons-material/VideocamOff'
import WallpaperIcon from '@mui/icons-material/Wallpaper'
import React from 'react'
import { ControlButton, ControlsBar } from './styles'
import { VIDEO_CALL_MEET_TEST_IDS } from './testIds'

interface Props {
  isAudioMuted: boolean
  isVideoEnabled: boolean
  isFullscreen: boolean
  onToggleAudio: () => void
  onToggleVideo: () => void
  onToggleFullscreen: () => void
  onToggleDevices: () => void
  onToggleBackground: () => void
  onEndCall: () => void
}

export default function VideoCallMeetControls({
  isAudioMuted,
  isVideoEnabled,
  isFullscreen,
  onToggleAudio,
  onToggleVideo,
  onToggleFullscreen,
  onToggleDevices,
  onToggleBackground,
  onEndCall,
}: Props) {
  return (
    <ControlsBar data-testid={VIDEO_CALL_MEET_TEST_IDS.controls}>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlMic}
        active={!isAudioMuted}
        onClick={onToggleAudio}
        title={isAudioMuted ? 'Ativar Microfone' : 'Mutar Microfone'}
        aria-label={isAudioMuted ? 'Ativar Microfone' : 'Mutar Microfone'}
      >
        {isAudioMuted ? (
          <MicOffIcon fontSize="large" />
        ) : (
          <MicIcon fontSize="large" />
        )}
      </ControlButton>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlVideo}
        active={isVideoEnabled}
        onClick={onToggleVideo}
        title={isVideoEnabled ? 'Desligar Video' : 'Ativar Video'}
        aria-label={isVideoEnabled ? 'Desligar Video' : 'Ativar Video'}
      >
        {isVideoEnabled ? (
          <VideocamIcon fontSize="large" />
        ) : (
          <VideocamOffIcon fontSize="large" />
        )}
      </ControlButton>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlDevices}
        onClick={onToggleDevices}
        title="Dispositivos"
        aria-label="Dispositivos"
      >
        <SettingsInputComponentIcon fontSize="large" />
      </ControlButton>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlBackground}
        onClick={onToggleBackground}
        title="Plano de Fundo"
        aria-label="Plano de Fundo"
      >
        <WallpaperIcon fontSize="large" />
      </ControlButton>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlFullscreen}
        onClick={onToggleFullscreen}
        title={isFullscreen ? 'Sair da Tela Cheia' : 'Tela Cheia'}
        aria-label={isFullscreen ? 'Sair da Tela Cheia' : 'Tela Cheia'}
      >
        {isFullscreen ? (
          <FullscreenExitIcon fontSize="large" />
        ) : (
          <FullscreenIcon fontSize="large" />
        )}
      </ControlButton>
      <ControlButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.controlEnd}
        danger
        onClick={onEndCall}
        title="Encerrar"
        aria-label="Encerrar"
      >
        <CallEndIcon fontSize="large" />
      </ControlButton>
    </ControlsBar>
  )
}
